export default "__VITE_ASSET__DTlKT8LM__"